//internal-deps
import { AnalyticsContextValue } from "@swiggy-private/analytics";

//constants
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@payment-client/analytics/constants";

//helpers
import { stringifyWithUndefinedKeys } from "@payment-client/analytics/helpers";

export const onImpressionTurboPay = (
    paymentCode: string,
    couponUsed: boolean,
    slider: boolean,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TURBO_PAY,
        label: paymentCode,
        context: JSON.stringify({ couponUsed, slider }),
    });
};

export const onImpressionTurboAmount = ({
    impressionEvent,
    billAmountShownOnCart,
    billTotal,
    payableAmount,
    billAmountFromRenderingDetails,
    uniqueId,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    billAmountShownOnCart: string;
    billTotal: string;
    payableAmount?: string;
    billAmountFromRenderingDetails?: string;
    uniqueId?: string;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TURBO_AMOUNT_MISMATCH,
        context: JSON.stringify({
            billAmountShownOnCart,
            billTotal,
            payableAmount,
            billAmountFromRenderingDetails,
            uniqueId,
        }),
    });
};

export const onClickTurboPay = ({
    paymentCode,
    clickEvent,
    slider,
    Width,
    groupCartId,
}: {
    paymentCode: string;
    clickEvent: AnalyticsContextValue["clickEvent"];
    slider: boolean;
    Width: number;
    groupCartId?: string;
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_TURBO_PAY,
        label: paymentCode,
        context: JSON.stringify({
            slider,
            Width,
        }),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};

export const onClickChange = (clickEvent: AnalyticsContextValue["clickEvent"], groupCartId?: string): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CHANGE,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};

export const onClickSlider = (clickEvent: AnalyticsContextValue["clickEvent"], widthPercent: number): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SLIDER,
        context: JSON.stringify({
            Width: widthPercent,
        }),
    });
};

export const onImpressionTurboPayMsgs = ({
    impressionEvent,
    billAmount,
    payableAmount,
    promoMsg,
    discountMsg,
    businessLine,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    billAmount?: string;
    payableAmount?: string;
    promoMsg?: string;
    discountMsg?: string;
    businessLine?: string;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_MESSAGE,
        context: stringifyWithUndefinedKeys({
            promo: promoMsg,
            discount: discountMsg,
            billAmount,
            payableAmount,
            businessLine,
        }),
    });
};

export const onImpressionChangeTooltip = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CHANGE_TOOLTIP,
    });
};

export const onClickChangeTooltip = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CHANGE_TOOLTIP,
    });
};
